import React from 'react'

import { DateInput } from 'ui/components/Input'

export const DateAndDateTimeDefaultValue: React.FC<{
    value: FieldDto['default_value']
    onChange: (value: FieldDto['default_value']) => void
    field: FieldDto
}> = ({ value, onChange, field }) => {
    // if the field type is being modified, selectedType is set - we want to show the default config for the new field
    // type, even before saved
    const effectiveFieldType = (field as any).selectedType ?? field.type

    const showTime = effectiveFieldType === 'datetime'
    return (
        <DateInput
            value={value?.value ? new Date(value.value) : undefined}
            onChange={(date) => {
                if (Array.isArray(date)) {
                    console.warn(
                        'unexpectedly received multiple dates for date/datetime default field config',
                        { date }
                    )
                    return
                }

                const formattedDate = showTime
                    ? date?.toISOString()
                    : date?.toISOString().split('T')[0]

                onChange({ type: 'constant', value: formattedDate })
            }}
            placeholder="Enter default value"
            showTime={showTime}
        />
    )
}
